var map = {
	"./adextre.png": [
		8853,
		8853
	],
	"./adextre_1.png": [
		5456,
		5456
	],
	"./adextre_2.png": [
		9876,
		3501
	],
	"./champagne.png": [
		4268,
		4268
	],
	"./champagne_1.png": [
		2837,
		2837
	],
	"./champagne_2.png": [
		9977,
		9977
	],
	"./chef.png": [
		3979,
		3979
	],
	"./chef_1.png": [
		8903,
		8903
	],
	"./chef_2.png": [
		2469,
		2469
	],
	"./coupe.png": [
		406,
		406
	],
	"./coupe_1.png": [
		1914,
		1914
	],
	"./coupe_2.png": [
		4666,
		4666
	],
	"./ecartele.png": [
		9146,
		9146
	],
	"./ecartele_1.png": [
		1802,
		1802
	],
	"./ecartele_2.png": [
		6097,
		6097
	],
	"./ecartele_3.png": [
		4201,
		4694
	],
	"./ecartele_4.png": [
		7059,
		7059
	],
	"./ecartele_sautoir.png": [
		5760,
		5760
	],
	"./ecartele_sautoir_1.png": [
		5167,
		5167
	],
	"./ecartele_sautoir_2.png": [
		9591,
		9591
	],
	"./ecartele_sautoir_3.png": [
		3855,
		3855
	],
	"./ecartele_sautoir_4.png": [
		1292,
		1292
	],
	"./parti.png": [
		925,
		925
	],
	"./parti_1.png": [
		1156,
		1156
	],
	"./parti_2.png": [
		7927,
		7927
	],
	"./plain.png": [
		2384,
		2384
	],
	"./senestre.png": [
		2332,
		2332
	],
	"./senestre_1.png": [
		7619,
		7619
	],
	"./senestre_2.png": [
		8157,
		8157
	],
	"./taille.png": [
		8758,
		8758
	],
	"./taille_1.png": [
		6460,
		6460
	],
	"./taille_2.png": [
		859,
		859
	],
	"./tierce_bande.png": [
		8153,
		8153
	],
	"./tierce_bande_1.png": [
		6974,
		6974
	],
	"./tierce_bande_2.png": [
		5163,
		5163
	],
	"./tierce_bande_3.png": [
		3583,
		3583
	],
	"./tierce_barre.png": [
		127,
		127
	],
	"./tierce_barre_1.png": [
		9123,
		9123
	],
	"./tierce_barre_2.png": [
		3648,
		3648
	],
	"./tierce_barre_3.png": [
		3706,
		3706
	],
	"./tierce_fasce.png": [
		9177,
		9177
	],
	"./tierce_fasce_1.png": [
		6128,
		6128
	],
	"./tierce_fasce_2.png": [
		9266,
		9266
	],
	"./tierce_fasce_3.png": [
		7014,
		7014
	],
	"./tierce_pairle.png": [
		3345,
		3345
	],
	"./tierce_pairle_1.png": [
		6628,
		6628
	],
	"./tierce_pairle_2.png": [
		2435,
		4201
	],
	"./tierce_pairle_3.png": [
		1502,
		1502
	],
	"./tierce_pairle_verse.png": [
		5106,
		5106
	],
	"./tierce_pairle_verse_1.png": [
		5333,
		5333
	],
	"./tierce_pairle_verse_2.png": [
		8916,
		6434
	],
	"./tierce_pairle_verse_3.png": [
		6289,
		6289
	],
	"./tierce_pal.png": [
		3511,
		3511
	],
	"./tierce_pal_1.png": [
		3433,
		3433
	],
	"./tierce_pal_2.png": [
		1635,
		1635
	],
	"./tierce_pal_3.png": [
		873,
		873
	],
	"./tranche.png": [
		6630,
		6630
	],
	"./tranche_1.png": [
		6767,
		6767
	],
	"./tranche_2.png": [
		9992,
		9992
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 6124;
module.exports = webpackAsyncContext;